import axios from "axios";
import { ChimeSDKMediaPipelinesClient, CreateMediaCapturePipelineCommand } from "@aws-sdk/client-chime-sdk-media-pipelines";
import { CLASSROOM_S3_PATH } from "../../utils/constants";
import { getDecryptedDataWithSecretKey } from "../../utils/helper";

export const chimeStartRecording = async (MeetingId: string) => {
    try {
        console.log("[Log] Start the meeting recording.", MeetingId);

        const backendUrl = process.env.REACT_APP_BACKEND_URL;

        if (!backendUrl) {
            throw new Error("Backend URL is not defined in environment variables");
        }

        const query = `
        query getRoleKeysInfo($type: String!) {
            getRoleKeysInfo(type: $type) {
                accessKeyId
                secretAccessKey
                sessionToken
                SourceArn
                SinkType
                SinkArn
                region
            }
        }
        `;

        // Fetch role keys and meeting configuration from the backend
        const responses = await axios.post(
            backendUrl,
            {
                query,
                variables: {
                    type: CLASSROOM_S3_PATH
                },
            },
            {
                headers: { "Content-Type": "application/json" },
            }
        );

        const { accessKeyId, secretAccessKey, SourceArn, SinkArn, region, sessionToken } = responses?.data?.data?.getRoleKeysInfo;

        if (!accessKeyId || !secretAccessKey || !sessionToken || !region) {
            throw new Error("Missing necessary credentials for Chime SDK");
        }

        const decryptedAccessKeyId = getDecryptedDataWithSecretKey(accessKeyId).originalText;
        const decryptedSecretAccessKey = getDecryptedDataWithSecretKey(secretAccessKey).originalText;
        const decryptedsessionToken = getDecryptedDataWithSecretKey(sessionToken).originalText;

        const client = new ChimeSDKMediaPipelinesClient({
            region, credentials: {
                accessKeyId: decryptedAccessKeyId,
                secretAccessKey: decryptedSecretAccessKey,
                sessionToken: decryptedsessionToken
            }
        });

        const input: any = {
            SourceType: "ChimeSdkMeeting",
            SourceArn: `${SourceArn}${MeetingId}`,
            SinkType: "S3Bucket",
            SinkArn: `${SinkArn}${MeetingId}/`,
            ChimeSdkMeetingConfiguration: {
                ArtifactsConfiguration: {
                    CompositedVideo: {
                        GridViewConfiguration: {
                            ContentShareLayout: 'Horizontal',
                        },
                        Layout: 'GridView',
                        Resolution: 'FHD',
                    },
                    Content: {
                        State: "Disabled",
                        MuxType: "ContentOnly",
                    },
                    Video: {
                        State: "Disabled",
                        MuxType: "VideoOnly"
                    },
                    Audio: {
                        State: "Enabled",
                        MuxType: "AudioWithCompositedVideo"
                    }
                }
            }

        };

        console.log("[Log] CreateMediaCapturePipelineCommand input", input);

        const command = new CreateMediaCapturePipelineCommand(input);
        const response = await client.send(command);
        return response;
    } catch (err: any) {
        console.error("[Log] Failed to start the recording.", err);
    }
}
